import { fetch_current_application_status } from '@/services/workflow_service';
import { status_dot_class } from '@/views/x-verdict_views/CaseOwner/AllCases/case_state';
import { normalize_text, response_status_label } from './view_case_details_helpers';

export default {
  apply_case_status(status_name) {
    const normalized_status = normalize_text(status_name);
    if (!normalized_status) {
      return '';
    }

    apply_summary_status(this, normalized_status);
    sync_status_to_store(this, normalized_status);
    return normalized_status;
  },
  async load_current_case_status({ throw_on_error = false } = {}) {
    if (!this.selected_application_id) {
      return '';
    }

    return load_current_status(this, throw_on_error);
  },
};

function apply_summary_status(component, normalized_status) {
  component.summary_rows = component.summary_rows.map((row) =>
    row.is_status
      ? { ...row, value: normalized_status, dot_class: status_dot_class(normalized_status) }
      : row
  );
}

function sync_status_to_store(component, normalized_status) {
  component.$store?.dispatch?.('syncStatusFromBackend', {
    id: component.selected_application_id || component.display_case_code,
    case_code: component.display_case_code,
    status: normalized_status,
  });
}

async function load_current_status(component, throw_on_error) {
  const response = await fetch_current_application_status({ application_id: component.selected_application_id })
    .catch((error) => current_status_error_result(error, throw_on_error));
  return response ? apply_loaded_status(component, response) : '';
}

function current_status_error_result(error, throw_on_error) {
  if (throw_on_error) {
    throw error;
  }

  return null;
}

function apply_loaded_status(component, response) {
  const status = response_status_label(response);
  return status && status.toLowerCase() !== 'success'
    ? component.apply_case_status(status)
    : '';
}
